import { Box, type BoxProps, styled } from "@mui/material";
import { rem } from "polished";
import React, { useContext } from "react";

import { ariaLabel } from "src/constants/app/aria-labels";
import { ERecoContext } from "src/contexts";
import { useBrand } from "src/hooks/useBrand";
import { isActivationKey } from "src/utils/activationKey";

const StyledRootBox = styled(Box)`
  background-color: ${(props) => props.theme.palette.primary.light};
  color: ${(props) => props.theme.palette.common.white};
  padding: ${(props) => props.theme.spacing(3)};
  text-align: center;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.down("sm")} {
    margin: ${(props) => props.theme.spacing(1)};
    border-radius: ${(props) => props.theme.spacing(0.5)};
  }
`;

const StyledTitle = styled("h2")`
  font-weight: bold;
  font-size: ${rem(24)};
  color: ${(props) => props.theme.palette.black.main};
`;

const StyledContent = styled("div")`
  width: 80%;
  margin: auto;
  color: ${(props) => props.theme.palette.black.main};
`;

export const ErecoSubscription = (boxProps: BoxProps) => {
  const { openEReco } = useContext(ERecoContext);
  const { customerPortal } = useBrand();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (isActivationKey(event)) {
      openEReco();
    }
  };

  return (
    <StyledRootBox
      {...boxProps}
      onClick={openEReco}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown}
      aria-label={ariaLabel.eRecoSubscriptionButtonLabel}
    >
      <StyledTitle>Ayez le bon réflexe, passez à l'E-reco</StyledTitle>
      <StyledContent role="presentation">
        <p>
          Ce service sécurisé de notification électronique vous permet de recevoir vos convocations
          et procès-verbaux d'assemblée générale dans votre espace {customerPortal.name}.
        </p>
        <p>
          Cette solution est pratique, éco-responsable et contribue à réduire le montant de vos
          charges de copropriété.
        </p>
      </StyledContent>
    </StyledRootBox>
  );
};
